export default __webpack_public_path__ + "static/media/docx.896e5b37.svg";